module.exports = __webpack_public_path__ + "img/mobile-features-tokens.22e08831.svg";